import React from 'react';
import clsx from "clsx";
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import PaperCard from './paper-card';

const useStyles = makeStyles(theme => ({
  header: {
    color: 'rgb(182, 193, 220)',
    fontSize: 18, 
    padding: theme.spacing(1, 0, 5, 0),
    fontWeight: 600
  },
  subHeader: {
    color: 'rgb(255, 255, 255)',
    fontWeight: 600,
    padding: theme.spacing(0, 0, 1, 0)
  },
  numberPercent: {
    width: 75,
    padding: theme.spacing(.3),
    borderRadius: 20,
    display: 'flex',
    justifyContent: 'center',
    alignItems:'center',
    fontSize: 20,
    color: 'rgb(2,206,178)',
    borderWidth: 1.5,
    borderColor: 'rgb(3,185,162)'
  },
  height: {
    height: 400
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  boxParent: {
    display:'flex',
    flexDirection:'column', 
    justifyContent:'space-around',
    alignItems:'center'
  },
  darkMode: {
    color: '#000',
  }
}));

export default function Conversation({theme}) {
  const classes = useStyles();
  const children = (
    <div className={classes.content}>
      <Typography variant="h6" component="p" className={classes.header}>
        Conversations
      </Typography>
      <Box className={classes.boxParent}>
        <Typography variant="h1" component="p" classes={{root: clsx(classes.subHeader, !theme ? classes.darkMode : null)}}>
          452
        </Typography>
        <Box className={classes.numberPercent} border={1}>
          -5,6%
        </Box>
      </Box>
    </div>
  )
  return (
    <PaperCard
      children={children}
      height={classes.height} 
      theme={theme}
    />
  );
}
